export const SALESFORCE_EVENT_DATE_FORMAT = 'YYYYMMDDTHHmmss';

export const MEETING_SELECTOR_BUTTON_HEIGHT = 54;

export const MEETING_DROPDOWN_UI_KEY_PATH = ['note', 'meetingDropdown'];

export const MEETING_SCROLLABLE_VIEW = 'meeting-scrollable-view';

export const CHOOSE_MEETING_BUTTON_ENABLED_UI_KEY_PATH = ['note', 'meetingButtonEnabled'];
